import { type Theme, type SxProps } from '@mui/material';

export default {
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
  }),
  loader: {
    strokeLinecap: 'round',
  },
} satisfies SxProps<Theme>;
